import { Toast, ToastContainer } from 'react-bootstrap';

const variantBg = {
  success: 'var(--main-green)',
  danger: 'var(--red-orange)',
  info: 'var(--teal)',
};

const ToastStack = ({ toasts, onDismiss }) => (
  <ToastContainer position="top-end" className="p-3 app-toast-container">
    {toasts.map(({ id, message, variant }) => (
      <Toast
        key={id}
        show
        onClose={() => onDismiss(id)}
        className="app-toast"
        style={{ backgroundColor: variantBg[variant] || variantBg.info }}
      >
        <Toast.Body className="text-white fw-medium">{message}</Toast.Body>
      </Toast>
    ))}
  </ToastContainer>
);

export default ToastStack;